// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"301":"02fbda1c","453":"ce085f75"}[chunkId] + ".chunk.js";
};